import { createSlice } from "@reduxjs/toolkit";
import { createConsigne } from "domain/consignes/consignes.actions";

export type ConsignesState = {
  isConsignesLoading: boolean;
};

const initialState: ConsignesState = {
  isConsignesLoading: false,
};

export const consignesSlice = createSlice({
  name: "consignes",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //CREATE TECHNIQUE
    builder.addCase(createConsigne.fulfilled, (state, action) => {
      state.isConsignesLoading = false;
    });
    builder.addCase(createConsigne.pending, (state, action) => {
      state.isConsignesLoading = true;
    });
  },
});
